module.exports = __webpack_public_path__ + "media/images/players/PEREZ_PAT-2b1a4aa4796ded8f811bd394f611c9cb.png";